<template>
  {{ format }}
</template>

<script>
import {percent} from "../../helpers/formatter"

export default {
  name: "Percent",

  props: {
    value: Number,
  },

  computed: {
    format() {
      return percent(this.value)
    },
  }
}
</script>
